import { MouseEvent, ReactNode, useState } from 'react';

import { useTranslation } from 'react-i18next';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TuneIcon from '@mui/icons-material/Tune';
import { Box, Button, ClickAwayListener, Paper, Popper } from '@mui/material';

const SettingsPopper = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('common');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;
  const id = open ? 'settings-popper' : undefined;

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <ClickAwayListener mouseEvent="onMouseUp" onClickAway={handleClickAway}>
        <div>
          <Button
            variant="outlined"
            size="small"
            startIcon={<TuneIcon />}
            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            aria-describedby={id}
            onClick={handleClick}
          >
            {t('settings')}
          </Button>
          <Popper
            placement="bottom-end"
            anchorEl={anchorEl}
            open={open}
            id={id}
          >
            <Paper>
              <Box py={4} px={3}>
                {children}
              </Box>
            </Paper>
          </Popper>
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default SettingsPopper;
